import styled from "styled-components"

export const StyledDeal = styled.div`
  margin: 4px 0 14px; /* Allow translate to expand somewhere */
  text-align: left;
  transition: transform .24s, box-shadow .24s;
  border-radius: 3px;

  ${({theme}) => theme.animations.hover}
  
  a {
    text-decoration: none;

    :hover {
      color: black;
    }
  }
`
